<template>
    <footer>
        <x-container fluid py-0 app-width>
            <x-layout align-center>
                <x-flex>
                    <p>Copyright © {{ year }} Howden Insurance Brokers ltd. Registration 725875.</p>
                </x-flex>
            </x-layout>

            <x-layout align-center>
                <x-flex>
                    <p>Version {{ version }}</p>
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex xs12>
                    <ul>
                        <li>
                            <a href="/assets/terms_and_conditions/Tepfin X - Terms and Conditions.docx">
                                Terms and Conditions
                            </a>
                        </li>
                    </ul>
                </x-flex>
            </x-layout>
        </x-container>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        computed: {
            year() {
                let date = new Date();

                return date.getFullYear();
            },
            version() {
                // eslint-disable-next-line no-process-env
                const source_branch_name = process.env.BUILD_SOURCEBRANCHNAME ?? '-';
                // eslint-disable-next-line no-process-env
                const source_version = process.env.BUILD_SOURCEVERSION ?? '-';
                const short_commit = source_version.slice(0, 7);

                const version =  source_branch_name.split('/');

                // Release branches match `release/x.x.x`
                const prefix = version[0] === 'release' ? version[1] : source_branch_name;

                return `${prefix}.${short_commit}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: $footer-height;
        padding-top: 32px;

        ul {
            display: flex;
            gap: 14px;
        }

        p, a {
            font-size: rem(11px);
            color: $color-white;
        }

        a {
            text-decoration: underline;
        }
    }
</style>
